import { AxiosResponseHeaders, RawAxiosResponseHeaders } from "axios";
import { IQueryParams, IQueryState } from "../app/interfaces/ISortableTable";

// axios 1.x types a response's headers as either the raw object or an
// AxiosHeaders instance, and a header value as string | string[] | number |
// boolean | null - so the two we read are coerced rather than assumed to be
// strings. A missing header still stringifies to something parseInt rejects,
// which is the NaN these two lines already relied on.
export const parseQueryState = (
    headers: RawAxiosResponseHeaders | AxiosResponseHeaders,
    queryParams?: IQueryParams,
) => {
    const maybePageNumber = parseInt(String(headers['page']));
    const maybeTotalPagesNumber = parseInt(String(headers['total_pages']));
    
    const queryState = {
      page: isNaN(maybePageNumber) ? undefined : maybePageNumber,
      totalPages: isNaN(maybeTotalPagesNumber) ? undefined : maybeTotalPagesNumber,
      search: queryParams?.search,
      sort: queryParams?.sort,
      reverse: queryParams?.reverse,
      trade: queryParams?.trade,
      cost_code: queryParams?.cost_code,
      include_inactive: queryParams?.include_inactive
    } as IQueryState;

    return queryState;
};
